export default {
  /**
   *
   * @param state
   * @param items
   */
  setEmployeeDashboardDailyAttendanceList(state, items) {
    console.log(items);
    state.items = items;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setEmployeeDashboardDailyAttendancePagination(state, pagination) {
    console.log("Pagination", pagination);
    state.pagination = pagination;
  },

  /**
   *
   * @param state
   * @param currentPage
   */
  setEmployeeDashboardDailyAttendancePage(state, currentPage) {
    state.pagination.current_page = currentPage;
  },

  /**
   * Teacher filters.
   *
   * @param state
   * @param filters
   */
  setEmployeeDashboardDailyAttendanceFilters(state, filters) {
    state.filters = filters;
  },

  /**
   * Set is busy
   *
   * @param state
   * @param isBusy
   */
  setEmployeeDashboardDailyAttendanceBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};
